export default __webpack_public_path__ + "images/bbc8a6caf1b6aed82fb7535ac6667b12-funbox_logo.svg";